/* ═══ INSIGNE — SEPET BÖLÜM YENİLEME KORUMASI ════════════════════════════════
   SORUN (Ali): sepette adet değişince "Estimated total" güncellenmiyordu.
   ÖLÇÜLDÜ (2026-07-30, gerçek tarayıcı): "+" basınca adet 3 oldu, SATIR toplamı
   479.70'e güncellendi, TAHMİNİ TOPLAM 287.82'de kaldı; sayfa yenilenince doğru
   değer geldi → sunucu doğru, hata DOM değişiminde.

   KÖK NEDEN — assets/cart.js:185-189
     this.getSectionsToRender().forEach((section) => {
       const elementToReplace =
         document.getElementById(section.id).querySelector(section.selector) || ...
   Dawn 4 bölüm yeniler: main-cart-items → cart-icon-bubble → cart-live-region-text
   → main-cart-footer. ⚠ Bu temada **`cart-icon-bubble` ELEMENTİ YOK**: Dawn onu
   `sections/header.liquid` içinde basar, biz ise `layout/theme.liquid`'de Dawn'ın
   header-group'unu kaldırıp `cinematic-header`'ı koyduk. → `getElementById` null
   → `null.querySelector` TypeError → forEach ORADA ÖLÜYOR → 1. bölüm (ürünler)
   güncelleniyor, 4. bölüm (TOPLAM) hiç sıraya gelmiyor.
   Hata görünmüyordu çünkü Dawn'ın kendi `.catch()`'i onu yutuyor.

   ÇÖZÜM: `getSectionsToRender`'ı sarıp DOM'da KARŞILIĞI OLMAYAN bölümleri ele.
   cart.js'e DOKUNULMUYOR (Dawn güncellemesi bunu ezmez), davranış değişmiyor;
   yalnızca var olmayan hedef atlanıyor. GERİ ALMA: bu dosya + tek script satırı.

   ⚠ İNDİRİMLER: toplam ve indirim satırı ("Buy 4+ Get 20% Off") sunucudan gelen
   bölüm HTML'i ile geliyor — yani adet eşiği aşılınca indirim de kendiliğinden
   yeniden hesaplanır. Burada indirim mantığına HİÇ dokunulmuyor.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  function patch() {
    var K = customElements.get('cart-items');
    if (!K || !K.prototype) return false;              // cart.js henüz gelmedi
    if (K.prototype.__ipSectionGuard) return true;
    var orig = K.prototype.getSectionsToRender;
    if (typeof orig !== 'function') return true;       // beklenmedik sürüm: karışma
    K.prototype.getSectionsToRender = function () {
      var list;
      try { list = orig.call(this); } catch (e) { return []; }
      if (!list || !list.filter) return list;
      return list.filter(function (s) {
        return s && s.id && document.getElementById(s.id);
      });
    };
    K.prototype.__ipSectionGuard = true;
    return true;
  }

  if (!patch()) {
    var tries = 0;
    var t = setInterval(function () {
      if (patch() || ++tries > 60) clearInterval(t);
    }, 100);
    document.addEventListener('DOMContentLoaded', patch);
  }

  /* ── Header sepet sayacı ──────────────────────────────────────────────────
     Dawn sayacı `cart-icon-bubble` bölümüyle günceller; o bölüm bu temada YOK
     (yukarıya bak) ve zaten temanın kendi sayacı var: `[data-minicart-count]`
     (etiket) + `[data-minicart-badge]` (rozet), cinematic-header.liquid:440/451.
     Temanın mini sepeti `cart:updated`'ı DİNLİYOR ama yalnız ÇEKMECE AÇIKKEN
     yeniliyor (cinematic-product.js:1854 `if(!mc.hidden) fetchCart()`), bu yüzden
     sepet sayfasında adet değişince sayaç eski kalıyordu (ÖLÇÜLDÜ: 5 yapıldı,
     rozet "Cart (2)" kaldı, ancak yenilemede düzeldi).
     Burada Dawn'ın kendi cartUpdate yayınına bağlanıp sayacı doğrudan yazıyoruz —
     ekstra ağ isteği YOK, sayı zaten yanıtın içinde geliyor. */
  function setCount(n) {
    if (typeof n !== 'number') return;
    var label = (window.INSIGNE_T && window.INSIGNE_T.cart) || 'Cart';
    /* Sayı artık ikon rozetinde (Ali 2026-08-05) — etikette "(N)" yazmıyoruz. */
    document.querySelectorAll('[data-minicart-count]').forEach(function (el) {
      el.textContent = label;
    });
    document.querySelectorAll('[data-minicart-badge]').forEach(function (el) {
      el.textContent = n;
      if (el.hasAttribute('data-cart-badge')) el.hidden = !n;   /* 0 iken rozet görünmesin */
    });
  }

  function hookCount() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var d = event && event.cartData;
      if (d && typeof d.item_count === 'number') setCount(d.item_count);
      /* temanın kendi mini sepeti açıksa kendi kendini zaten yeniler */
      document.dispatchEvent(new CustomEvent('cart:updated'));
    });
    return true;
  }
  if (!hookCount()) {
    var n = 0;
    var t2 = setInterval(function () {
      if (hookCount() || ++n > 60) clearInterval(t2);
    }, 100);
  }
})();
